module.exports = __webpack_public_path__ + "img/clouds.83dd9350.jpg";